// frontend/src/pages/Dashboard/ReaderDashboard.js

import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import axiosInstance from '../../utils/axiosConfig';

const ReaderDashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [totalComments, setTotalComments] = useState(0);

  useEffect(() => {
    fetchMyCommentsCount();
  }, []);

  const fetchMyCommentsCount = async () => {
    setLoading(true);
    try {
      const { data } = await axiosInstance.get('/comments/my-comments');
      setTotalComments(data.length);
    } catch (err) {
      setError('Fehler: Konnte eigene Kommentare nicht laden.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen">
      {/* SIDEBAR */}
      <div className={`${sidebarOpen ? 'block' : 'hidden'} sm:block bg-gray-100 w-64 p-4`}>
        {/* Close toggle (mobile) */}
        <button onClick={() => setSidebarOpen(false)} className="sm:hidden mb-4">
          <XMarkIcon className="w-6 h-6 text-gray-600" />
        </button>

        {/* Zurück-Button */}
        <button
          onClick={() => navigate(-1)}
          className="bg-primary text-white w-full text-left px-4 py-2 rounded hover:bg-orange-600 mb-2"
        >
          ← Zurück
        </button>

        {/* Reader Links */}
        <Link
          to="/reader/dashboard"
          className="block bg-primary text-white px-4 py-2 rounded hover:bg-orange-600 mb-2"
        >
          Leser-Dashboard
        </Link>
        <Link
          to="/reader/my-comments"
          className="block bg-primary text-white px-4 py-2 rounded hover:bg-orange-600"
        >
          Meine Kommentare
        </Link>
      </div>

      {/* MAIN CONTENT */}
      <div className="flex-1 p-4">
        {/* Mobile toggle */}
        <button onClick={() => setSidebarOpen(true)} className="sm:hidden mb-4">
          <Bars3Icon className="w-6 h-6 text-gray-600" />
        </button>

        <motion.div className="py-8" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <h1 className="text-3xl font-heading text-primary mb-6">Leser-Dashboard</h1>
          <p className="mb-4">
            Ihre Lesepräferenzen und Kommentarhistorie finden Sie hier.
          </p>

          {error && <div className="bg-red-100 text-red-700 p-2 mb-4">{error}</div>}

          {loading ? (
            <div className="flex justify-center">
              <div className="loader" />
            </div>
          ) : (
            <div className="bg-secondary text-white p-6 rounded hover:bg-orange-600 transition inline-block">
              <h2 className="text-xl font-heading">Meine Kommentare</h2>
              <p className="text-2xl mt-2 font-bold">{totalComments}</p>
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default ReaderDashboard;
